module.exports = __webpack_public_path__ + "static/media/tinmold.aa061285.jpg";